var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8346 27.778C24.2642 27.778 21.6586 27.1697 19.018 25.953C16.3773 24.7363 13.9476 23.0095 11.729 20.7727C9.49208 18.554 7.7653 16.1262 6.54863 13.4893C5.33197 10.8522 4.72363 8.24266 4.72363 5.66066C4.72363 5.25377 4.86119 4.91232 5.1363 4.63632C5.41141 4.36055 5.7553 4.22266 6.16797 4.22266H10.9236C11.2347 4.22266 11.5004 4.32721 11.7206 4.53632C11.9411 4.74566 12.0902 5.01143 12.168 5.33366L13.0553 9.59232C13.0933 9.89032 13.0817 10.1643 13.0206 10.4143C12.9595 10.6643 12.844 10.8761 12.674 11.0497L9.4403 14.3337C9.97719 15.2597 10.5571 16.1274 11.18 16.937C11.8031 17.7468 12.4899 18.5179 13.2403 19.2503C14.0032 20.0354 14.8115 20.7582 15.6653 21.4187C16.5189 22.0789 17.4197 22.6728 18.368 23.2003L21.5466 19.978C21.7497 19.7595 21.9821 19.6095 22.2436 19.528C22.5052 19.4467 22.7689 19.4263 23.0346 19.467L27.1426 20.3323C27.4706 20.411 27.7421 20.5801 27.957 20.8397C28.1716 21.0994 28.279 21.39 28.279 21.7113V26.3337C28.279 26.7463 28.1414 27.0902 27.8663 27.3653C27.5912 27.6404 27.2473 27.778 26.8346 27.778ZM8.39563 12.378L10.929 9.82266L10.2123 6.33366H6.8623C6.9143 7.24477 7.06063 8.19666 7.3013 9.18932C7.54197 10.1818 7.90674 11.2447 8.39563 12.378ZM20.3513 24.2003C21.2291 24.6077 22.1747 24.9373 23.1883 25.1893C24.2019 25.4411 25.1951 25.5929 26.168 25.6447V22.2893L22.879 21.5947L20.3513 24.2003Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalls);
export default __webpack_public_path__ + "static/media/calls.28f11734184b2e2e4e71a922e63ae8f8.svg";
export { ForwardRef as ReactComponent };